@let m = meeting();

@if (videoUrl(); as url) {
  <div class="player player--video">
    <video
      #player
      class="player__video"
      [controls]="!capa()"
      preload="metadata"
      [src]="url"
      (timeupdate)="aoTocar()"
      (seeked)="aoTocar()"
      (loadedmetadata)="aoCarregar()"
      (play)="aoComecar()"
      (error)="aoFalhar()"></video>
    @if (capa()) {
      <button
        type="button"
        class="player__cover"
        aria-label="Assistir à gravação"
        (click)="assistir()">
        <img class="player__cover-logo" src="assets/images/logo-cognito.png" alt="" />
        <span class="player__cover-play" aria-hidden="true"><i class="pi pi-play"></i></span>
        <span class="player__cover-label">
          Assistir à gravação
          @if (duracaoDoVideo(); as d) {
            · {{ d }}
          }
        </span>
      </button>
    }
  </div>
} @else if (videoErro()) {
  <div class="player player--state">
    <i class="pi pi-exclamation-circle player__icon" aria-hidden="true"></i>
    <strong>{{ videoErro() }}</strong>
    <app-button
      [label]="'Carregar de novo'"
      [icon]="'pi pi-refresh'"
      [size]="'small'"
      [type]="'button'"
      (sendButtonClick)="carregarDeNovo.emit()" />
  </div>
} @else if (m.hasRecording) {
  <div class="player player--state">
    <app-cog-loading-spinner />
  </div>
} @else if (processamento(); as p) {
  <!-- Opção 4 do protótipo: a gravação ainda está a caminho. -->
  <div class="player player--state player--processing" role="status">
    <span class="player__ring" aria-hidden="true"></span>
    <strong>{{ p.titulo }}</strong>
    <span>{{ p.texto }}</span>
  </div>
} @else {
  <div class="player player--state">
    @if (m.status === 'Cancelled') {
      <i class="pi pi-calendar-times player__icon" aria-hidden="true"></i>
      <strong>A reunião foi cancelada.</strong>
      <span>Ela foi removida do calendário e não será gravada.</span>
    } @else if (m.status === 'Rescheduled') {
      <!-- Card 3191: o horário mudou no calendário e a gravação vai na reunião do horário novo. -->
      <i class="pi pi-calendar player__icon" aria-hidden="true"></i>
      <strong>A reunião foi remarcada.</strong>
      <span>
        @if (m.rescheduledToStartAt) {
          Ela mudou para {{ m.rescheduledToStartAt | vaultDateTime }} no calendário, e o bot grava
          no horário novo.
        } @else {
          O horário mudou no calendário, e o bot grava no horário novo.
        }
      </span>
    } @else if (aindaNaoAconteceu()) {
      <i class="pi pi-clock player__icon" aria-hidden="true"></i>
      <strong>A reunião ainda não aconteceu.</strong>
      <span>
        @if (m.status === 'Scheduled') {
          O bot vai entrar e gravar no horário.
        } @else {
          Esta reunião está sem bot: ela não será gravada.
        }
      </span>
    } @else if (semGravacao(); as motivo) {
      <i [class]="motivo.icone + ' player__icon'" aria-hidden="true"></i>
      <strong>{{ motivo.titulo }}</strong>
      <span>{{ motivo.texto }}</span>
    } @else {
      <i class="pi pi-video player__icon" aria-hidden="true"></i>
      <strong>Esta reunião não tem vídeo.</strong>
    }
  </div>
}

@if (gravacaoParcial(); as aviso) {
  <p class="player__partial" role="note">
    <i class="pi pi-exclamation-triangle" aria-hidden="true"></i> {{ aviso }}
    <button type="button" class="player__partial-link" (click)="verLinhaDoTempo.emit()">
      Veja a linha do tempo
    </button>
  </p>
}

@if (processamento(); as p) {
  @if (m.hasRecording) {
    <p class="steps__note" role="status">
      <strong>{{ p.titulo }}.</strong> {{ p.texto }}
    </p>
  }
  <ol class="steps" aria-label="Andamento da gravação">
    @for (etapa of p.etapas; track etapa.rotulo; let i = $index) {
      <li [class]="'steps__item steps__item--' + etapa.estado">
        <span class="steps__dot" aria-hidden="true">
          @switch (etapa.estado) {
            @case ('feito') {
              <i class="pi pi-check"></i>
            }
            @case ('atual') {
              <i class="pi pi-sync"></i>
            }
            @default {
              {{ i + 1 }}
            }
          }
        </span>
        <span class="steps__label">
          {{ etapa.rotulo }}
        </span>
      </li>
    }
  </ol>
}
